export default function useSliderRange(
  minDiscount,
  maxDiscount,
  divisionsForDiscount,
  labels,
  setAllFilters
) {
  const sliderProps = {
    field: {
      valueField: {
        name: '',
        id: '',
        value: null,
      },
      model: {
        min: minDiscount.value,
        max: maxDiscount.value,
        step: Math.round(maxDiscount.value / divisionsForDiscount.value),
        displayDivisions: true,
        divisions: divisionsForDiscount.value,
        defaultValue1: minDiscount.value,
        defaultValue2: maxDiscount.value,
        multiRange: true,
        description: '',
        placeholder1: '',
        placeholder2: '',
        label1: labels?.minInputLabel?.value,
        label2: labels?.maxInputLabel?.value,
        prefix1: labels?.minInputAdornmentText?.value,
        prefix2: labels?.maxInputAdornmentText?.value,
      },
      originalValue: [minDiscount, maxDiscount],
    },
    onChange: (name, value) => {
      if (value[0] !== null && value[1] !== null) {
        let type = 'discount';
        //unpush  the discount
        setAllFilters((prev) => {
          return {
            ...prev,
            tagFilter: prev?.tagFilter?.filter((elt) => elt.type !== type),
            discountFilter: { from: minDiscount.value, to: maxDiscount.value, id: 'discount' },
          };
        });

        if (value[0] !== minDiscount.value || value[1] !== maxDiscount.value) {
          //push with tag when we dont have the initial state of the from to values
          setAllFilters((prev) => {
            return {
              ...prev,
              tagFilter: [
                ...prev?.tagFilter,
                {
                  title: `${value[0]}%-${value[1]}%`,
                  type: type,
                  id: 'discount',
                },
              ],
              discountFilter: { from: value[0], to: value[1], id: 'discount' },
            };
          });
        } else {
          //push without the tag for the default initial values
          setAllFilters((prev) => {
            return {
              ...prev,
              discountFilter: { from: value[0], to: value[1], id: 'discount' },
            };
          });
        }
      }
    },
    tracker: {
      onFocusField: () => {},
      onBlurField: () => {},
    },
    errors: null,
  };

  return { sliderProps };
}
